// client/src/services/authService.js
import axios from '../utils/axiosConfig';

export const login = async (credentials) => {
  try {
    const response = await axios.post('/auth/login', credentials);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to login');
  }
};

export const logout = async () => {
  try {
    await axios.post('/auth/logout');
    localStorage.removeItem('isAuthenticated');
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Failed to logout');
  }
};